import $http from '$http';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';

export default {
    getAllProvince({ commit, state }) {
        //GET /api/Common/GetProvinces
        $http.get('api/Common/GetProvinces', {
            Sid: state.sysSid,
            Session: state.sysSession,
        }).then(res => {
            util.doResult(this, res, () => {});
            let { Data } = res.data;
            commit('saveAllProvince', Data);
        });
    },
    getAllCity({ commit, state }) {

        $http.getV2('http://union.iqeq.cn/api/AgentTemp/GetAllCity', {}).then(res => {
            util.doResult(this, res, () => {});
            let { Data } = res.data;
            let newArray = [];

            function changeList(list) {
                for (var i = 0; i < list.length; i++) {
                    newArray.push({
                        Code: list[i].Code,
                        Name: list[i].Name
                    });
                    if (list[i].hasOwnProperty("level")) {
                        changeList(list[i]["level"])
                    }
                }
            }
            changeList(Data.List);
            commit('saveAllCity', newArray);
        });
    },
    getSession({ commit, state }) {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            commit("saveSession", user)
        }
    },
    getRouterName({ commit, state }, routerName) {
        commit("saveRouterName", routerName);
    },
    getCustomerLevelList({ commit, state }) {
        $http.get('api/Common/GetCrmConfig', {
            Sid: state.sysSid,
            Session: state.sysSession,
            ParentId: 2
        }).then(res => {
            util.doResult(this, res, () => {});
            let { Data } = res.data;
            commit('saveCustomerLevelList', Data);
        });
    },
    getCustomerSourceList({ commit, state }) {
        $http.get('api/Common/GetCrmConfig', {
            Sid: state.sysSid,
            Session: state.sysSession,
            ParentId: 3
        }).then(res => {
            util.doResult(this, res, () => {});
            let { Data } = res.data;
            commit('saveCustomerSourceList', Data);
        });
    },
    getAgentTypeList({ commit, state }) {
        $http.get('api/Agent/GetAgentTypeList', {
            Sid: state.sysSid,
            Session: state.sysSession
        }).then(res => {
            util.doResult(this, res, () => {});
            let { Data } = res.data;
            commit('saveAgentTypeList', Data);
        });
    },
    getAgentList({ commit, state }) {
        var Params = {
            Sid: state.sysSid,
            Session: state.sysSession,
            pageSize: 100000
        };
        $http.get("api/Common/GetAgentList", Params).then(res => {
            util.doResult(this, res, () => {});
            let { Data } = res.data;
            
            commit("saveAgentList", Data);
        });
    },
    getProjectTypeSignMateriel({ commit, state }) {
        var Params = {
            Sid: state.sysSid,
            Session: state.sysSession,
            pageSize: 100000
        };
        $http.get("api/Agent/GetProjectTypeSignMateriel", Params).then(res => {
            util.doResult(this, res, () => {});
            let { Data } = res.data;
            commit("saveProjectTypeSignMateriel", Data);
        });
    }

}


// WEBPACK FOOTER //
// ./src/vuex/action.js